import { RemixBrowser } from '@remix-run/react'
import posthog from 'posthog-js'
import { startTransition, StrictMode, useEffect } from 'react'
import { hydrateRoot } from 'react-dom/client'

// Disable Sentry for now to avoid DSN errors
// if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
// 	import('./utils/monitoring.client.tsx').then(({ init }) => init())
// }

function PosthogInit() {
	useEffect(() => {
		posthog.init('phc_jcUzDeJlDzTQ9uyv77zI5CCIPIcMfBzUlSmUJ5j5W4m', {
			api_host: 'https://posthog.wt.ls',
			person_profiles: 'identified_only',
		})
	}, [])

	return null
}

startTransition(() => {
	hydrateRoot(
		document,
		<StrictMode>
			<RemixBrowser />
			<PosthogInit />
		</StrictMode>,
	)
})
